import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Sms`;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null) {
      if (key == "portalList" && value.length > 0) {
        let portalListSTR = "";
        value.forEach(item => {
          portalListSTR += "portalList=" + item.value + "&"
        });
        stringparams = stringparams + portalListSTR;
        //stringparams = stringparams + value;
      }
      else {
        stringparams = stringparams + key + "=" + value + "&";
      }
    }
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}
const ApiSms = {
  getAllSms: (params) => {
    const url = `${baseServiceUrl}/getAllSms` + paramsToStringList(params);
    return ServiceApi.get(url);
  },
  sendGroupSms: (params) => {
    const url = `${baseServiceUrl}/sendGroupSms`;
    return ServiceApi.post(url, params);
  },

};

export default ApiSms;


